<pr-form
  (onSubmit)="submit()"
  title="Parrainer un nouveau filleul"
  [formGroup]="form"
>
  <pr-input-radio
    formControlName="gender"
    label="Civilité"
    [options]="[
      { value: 'M', label: 'Homme' },
      { value: 'F', label: 'Femme' },
    ]"
  >
  </pr-input-radio>

  <pr-input label="Prénom" [derrors]="derrors">
    <input formControlName="firstname" type="text" />
  </pr-input>

  <pr-input label="Nom" [derrors]="derrors">
    <input formControlName="lastname" type="text" />
  </pr-input>

  <pr-input label="Email" [derrors]="derrors">
    <input formControlName="email" type="text" />
  </pr-input>

  <pr-input label="Numéro de téléphone" [derrors]="derrors">
    <input formControlName="number" type="text" />
  </pr-input>
</pr-form>
